import PropTypes from 'prop-types';
import { Form, Button } from 'react-bootstrap';
import { Field, ErrorMessage, FieldArray } from 'formik';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { roleAndPermissionsService } from '../../services';
import { API_FAILURE_ERROR } from '../../constants';
import Loading from '../Loader';

const InviteNewTeamMember = ({
  formProps,
  showPlanText,
  maxInputField,
  fieldName,
  maxFieldAllowed,
}) => {
  const [options, setuserTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    roleAndPermissionsService
      .get_user_types()
      .then((response) => {
        if (response) {
          setIsLoading(false);
          setuserTypes(response.data);
        }
      })
      .catch((errResponse) => {
        toast.error(API_FAILURE_ERROR);
      });
  }, []);

  return (
    <>
      {isLoading && <Loading contentAreaOnly />}
      <Form.Group>
        {showPlanText && <div className="alert alert-info">{showPlanText}</div>}
        <div className="row pe-3">
          <div className="col-12 col-md-5">
            <Form.Label>
              Email Id <span className="text-danger">*</span>
            </Form.Label>
          </div>
          <div className="col-12 col-md-3 ps-0">
            <Form.Label>Employee Id</Form.Label>
          </div>
          <div className="col-12 col-md-3 ps-0">
            <Form.Label>
              Select user type <span className="text-danger">*</span>
            </Form.Label>
          </div>
          <div className="col-12 col-md-1" />
        </div>
        <div className="scroll-invite-team-member-email">
          <FieldArray
            name={fieldName}
            render={(arrayHelpers) => (
              <div>
                {formProps.values[fieldName] &&
                  formProps.values[fieldName].length > 0 &&
                  formProps.values[fieldName].map((emails, index) => (
                    <div
                      key={index}
                      className={
                        formProps.values[fieldName].length > 4
                          ? 'pe-2 row'
                          : 'pe-0 row'
                      }
                    >
                      <div className="col-12 col-md-5">
                        <Form.Group
                          key={index}
                          className="form-control-label label-required mb-3"
                        >
                          <Field
                            className="form-control inputhovershow"
                            type="text"
                            placeholder="name@example.com"
                            name={`${fieldName}.${index}.email`}
                          />
                          <ErrorMessage
                            name={`${fieldName}.${index}.email`}
                            render={(msg) => (
                              <small className="text-danger">{msg}</small>
                            )}
                          />
                        </Form.Group>
                      </div>
                      <div className="col-12 col-md-3 ps-0">
                        <Form.Group
                          key={index}
                          className="form-control-label label-required mb-3"
                        >
                          <Field
                            className="form-control inputhovershow"
                            type="text"
                            placeholder="EID7890"
                            name={`${fieldName}.${index}.employeeId`}
                          />
                          <ErrorMessage
                            name={`${fieldName}.${index}.employeeId`}
                            render={(msg) => (
                              <small className="text-danger">{msg}</small>
                            )}
                          />
                        </Form.Group>
                      </div>
                      <div className="col-12 col-md-3 mr-1 ps-0">
                        <Form.Group
                          key={index}
                          className="form-control-label label-required mb-3"
                        >
                          <Select
                            name={`${fieldName}.${index}.userType`}
                            options={options.map((item) => {
                              item.label =
                                item.label.charAt(0).toUpperCase() +
                                item.label.slice(1);
                              return item;
                            })}
                            menuPortalTarget={document.querySelector('body')}
                            onChange={(event) => {
                              formProps.setFieldValue(
                                `${fieldName}.${index}.userType`,
                                event.value
                              );
                            }}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary: '#0649b5',
                                neutral10: '#edf2f9',
                                neutral20: '#d2ddec',
                                neutral30: '#d2ddec',
                                neutral50: '#b1c2da',
                                neutral80: '#12263f',
                                dangerLight: '#DEEBFF',
                                danger: '#12263f',
                              },
                            })}
                            styles={{
                              indicatorSeparator: () => {}, // Disable indicator separator
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />

                          <ErrorMessage
                            name={`${fieldName}.${index}.userType`}
                            render={(msg) => (
                              <small className="text-danger">{msg}</small>
                            )}
                          />
                        </Form.Group>
                      </div>
                      <div className="col-12 col-md-1 mr-1  ps-0">
                        {formProps.values[fieldName].length > 1 && (
                          <Button
                            // className="email-invite-close-button"
                            variant="link"
                            onClick={() => {
                              arrayHelpers.remove(index);
                            }}
                          >
                            <i className="mdi mdi-window-close " />
                          </Button>
                        )}
                      </div>
                    </div>
                  ))}
                {maxInputField > 0 ? (
                  <div className="mb-4">
                    {formProps.values[fieldName] &&
                      formProps.values[fieldName].length < maxInputField && (
                        <a
                          href="true"
                          onClick={(e) => {
                            e.preventDefault();
                            arrayHelpers.push({
                              email: '',
                              employeeId: '',
                              userType: '',
                            });
                          }}
                        >
                          + Add another
                        </a>
                      )}
                  </div>
                ) : (
                  formProps.values[fieldName].length < maxFieldAllowed && (
                    <div className="mb-4">
                      <a
                        href="true"
                        onClick={(e) => {
                          e.preventDefault();
                          arrayHelpers.push({
                            email: '',
                            employeeId: '',
                            userType: '',
                          });
                        }}
                      >
                        + Add another
                      </a>
                    </div>
                  )
                )}
              </div>
            )}
          />
        </div>
      </Form.Group>
    </>
  );
};

InviteNewTeamMember.propTypes = {
  formProps: PropTypes.any,
  showPlanText: PropTypes.string,
  maxInputField: PropTypes.number,
  fieldName: PropTypes.string,
  maxFieldAllowed: PropTypes.number,
};

export default InviteNewTeamMember;
